import { z } from 'zod';

export const ThemeModeSchema = z.enum(['light','dark','overall']);

export type ThemeModeType = `${z.infer<typeof ThemeModeSchema>}`

export default ThemeModeSchema;
